import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoschUiTableComponent } from './bosch-ui-table.component';
import { BoschUiTableRowComponent } from './bosch-ui-table-row/bosch-ui-table-row.component';
import { BoschUiTableCellComponent } from './bosch-ui-table-cell/bosch-ui-table-cell.component';
import { BoschUiColumnDefDirective } from './directives/bosch-ui-column-def.directive';
import { BoschUiCellDefDirective } from './directives/bosch-ui-cell-def.directive';
import { BoschUiRowDefDirective } from './directives/bosch-ui-row-def.directive';
import { BoschUiTableHeaderRowComponent } from './bosch-ui-table-header-row/bosch-ui-table-header-row.component';
import { BoschUiTableHeaderCellComponent } from './bosch-ui-table-header-cell/bosch-ui-table-header-cell.component';
import { BoschUiHeaderCellDefDirective } from './directives/bosch-ui-header-cell-def.directive';
import { BoschUiHeaderRowDefDirective } from './directives/bosch-ui-header-row-def.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    BoschUiTableComponent,
    BoschUiTableRowComponent,
    BoschUiTableCellComponent,
    BoschUiColumnDefDirective,
    BoschUiCellDefDirective,
    BoschUiRowDefDirective,
    BoschUiTableHeaderRowComponent,
    BoschUiTableHeaderCellComponent,
    BoschUiHeaderCellDefDirective,
    BoschUiHeaderRowDefDirective,
  ],
  exports: [
    BoschUiTableComponent,
    BoschUiTableRowComponent,
    BoschUiTableCellComponent,
    BoschUiColumnDefDirective,
    BoschUiCellDefDirective,
    BoschUiRowDefDirective,
    BoschUiTableHeaderCellComponent,
    BoschUiTableHeaderRowComponent,
    BoschUiHeaderCellDefDirective,
    BoschUiHeaderRowDefDirective,
  ],
})
export class BoschUiTableModule {}
